module.exports = __webpack_public_path__ + "static/img/v70-1.6bb0ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70-1.png
// module id = 9rs8
// module chunks = 1